import { createRoute } from '@tanstack/react-router';
import { labParentRoute } from 'pages/lab/labParentRoute';

export const labRegionNewRoute = createRoute({
  getParentRoute: () => labParentRoute,
  path: '/regions/new',
}).lazy(() => import('pages/lab/Regions/LabRegionNewPage/LabRegionNewPage').then((d) => d.Route));
